import { Calendar as CalendarIcon } from "lucide-react";
import { DateTime } from "luxon";
import * as React from "react";

import { cn } from "@/lib/utils";
import { DateRange } from "react-day-picker";
import { Button } from "./button";
import { Calendar } from "./calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";

interface DatePickerRangeProps {
    date?: DateRange;
    setDate: (date?: DateRange) => void;
    placeholder?: string;
    className?: string;
    enableWeekend?: boolean;
}

export function DatePickerRange({ date, setDate, placeholder = "Select a date", className, enableWeekend = true }: DatePickerRangeProps) {
    const [range, setRange] = React.useState<DateRange | undefined>(date);

    React.useEffect(() => {
        setDate(range);
    }, [range]);

    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button variant={"outline"} className={cn("justify-start text-left font-normal", !date && "text-muted-foreground", className)}>
                    <CalendarIcon className="mr-2 h-4 w-4" />
                    {range && range.from && range?.to ? (
                        `${DateTime.fromJSDate(range.from).toLocaleString(DateTime.DATE_SHORT)} - ${DateTime.fromJSDate(range.to).toLocaleString(DateTime.DATE_SHORT)}`
                    ) : (
                        <span>{placeholder}</span>
                    )}
                </Button>
            </PopoverTrigger>
            <PopoverContent className="z-50 w-auto p-0">
                <Calendar mode="range" selected={range} onSelect={setRange} initialFocus enableWeekend={enableWeekend} />
            </PopoverContent>
        </Popover>
    );
}
